// extracted by mini-css-extract-plugin
export default {"loader":"Loader_loader__az6VC","rotate":"Loader_rotate__chv3j"};